import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import App from "./app/layout/App";
import "./index.scss";

import { BrowserRouter } from "react-router-dom";
import { configureStore } from "./store/configureStore";

import firebase from "firebase/app";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";
import ReduxToastr from "react-redux-toastr";
import { createFirestoreInstance } from "redux-firestore";
import ScrollToTop from "../src/app/common/scroltotop/ScrollToTop.jsx";
import ModalManager from "./app/common/modals/ModalManager";
const store = configureStore();

const rootEl = document.getElementById("root");
const rrfConfig = {
  userProfile: "users",
  attachAuthIsReady: true,
  useFirestoreForProfile: true,
  updateProfileOnLogin: false,
  createFirestoreInstance,
};
const rrfProps = {
  firebase,
  config: rrfConfig,
  attachAuthIsReady: true,
  dispatch: store.dispatch,
  createFirestoreInstance, // <- needed if using firestore
};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ReactReduxFirebaseProvider
        {...rrfProps}
        attachAuthIsReady={true}
        createFirestoreInstance={createFirestoreInstance}
      >
        <ModalManager />
        <BrowserRouter>
          <ScrollToTop>
            <ReduxToastr
              position="top-right"
              transitionIn="fadeIn"
              transitionOut="fadeOut"
              timeOut={4000}
              closeOnToastrClick
            />
            <App />
          </ScrollToTop>
        </BrowserRouter>
      </ReactReduxFirebaseProvider>
    </Provider>
  </React.StrictMode>,
  rootEl
);

// reportWebVitals();
